<template>
  <div>
    <div class="title">{{ title }} ({{ list.length }}个)</div>
    <draggable
      v-model="list"
      handle=".canDraggable"
      :animation="200"
      :group="dragGroup"
      @start="dragging = true"
      @end="dragEnd">
      <transition-group :style="style">
        <div class="child" v-for="(item, index) in list" :key="item.id">
          <img :src="getIcon(type)" alt="" srcset="" />
          <div class="item-content">
            <a-tooltip placement="topLeft" class="name" :class="{ drag: dragIndex === index}">
              <template slot="title">
                {{ item.name || item.title }}
              </template>
              {{ item.name || item.title }}
            </a-tooltip>
            <div class="operate">
              <img class="canDraggable" src="@/assets/icons/icon_yd.png" alt="" srcset="">
              <img @click="del(item)" src="@/assets/icons/icon_sc.png" alt="" srcset="">
            </div>
          </div>
        </div>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
import { getIcon } from '@/utils/other'
import draggable from 'vuedraggable'
export default {
  components: {
    draggable
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dragging: false,
      getIcon: getIcon
    }
  },
  methods: {
    dragGroup() {
      return {
        name: this.type,
        pull: false,
        put: false
      }
    },
    dragEnd() {
      this.dragging = false
      const obj = {
        type: this.type,
        list: [...this.list]
      }
      this.$emit('prepareMove', obj)
    },
    del(obj) {
      obj.type = this.type
      this.$emit('prepareDel', obj)
    }
  }
}
</script>

<style lang="less" scoped>
.title{
  font-size: 18px;
  font-weight: 550;
  margin-bottom: 9px;
}

.child{
  display: flex;
  font-size: 16px;
  cursor: pointer;
  align-items: center;
  // margin-bottom: 22px;
  position: relative;
  img{
    width: 26px;
    height: 26px;
    border-radius: 4px;
  }
  .item-content{
    height: 41px;
    display: flex;
    padding: 0 10px;
    overflow: hidden;
    justify-content: center;
    flex-direction: column;
    width: calc(100% - 26px);
    .name{
      width: 100%;
      font-weight: 500;
      overflow: hidden;
      text-wrap: nowrap;
      text-overflow: ellipsis;
    }
    .operate{
      bottom: 0;
      left: 46px;
      width: 50px;
      display: none;
      img{
        width: 13px;
        height: 13px;
        cursor: pointer;
        border-radius: 0;
        &:first-child{
          margin-right: 10px;
        }
      }
    }
  }
  .item-content:hover .operate{
    display: block;
    animation-duration: 1s;
    animation-name: slidein;
  }
  &:last-child{
    margin-bottom: 40px;
  }
  .name {
    font-size: 14px;
  }
}
.child:hover{
  .name{
    color: #FF6D00;
    font-weight: 550;
  }
}
</style>
